import React from 'react'
import {   Field} from 'redux-form'

export class SVMCOInputEp extends React.Component{

    constructor(props){
        super(props)
        let me = this
        this.svDDChange = this.svDDChange.bind(me)
    }
  
    svDDChange(e){
        //this.refs.DropdownList.refs
        //this.refs.DropdownList.refs.inner.handleClick()
        console.log('sv*****Sep2******country selected')
        console.log(e)
        console.log(e.target.value)
        let orgm = e.target.value
        let orgi = e.currentTarget.id 
        let orgOb = {
            orgi :orgm
        }

        this.props.svCountryChange(orgm,orgi)
/*
        //ob.target.value
        if(e.target.value =='string'){
            console.log('sv change action to change class')
           // this.props.initialValues.gene
            this.svfieldType= 'CL_String'
        }else if(e.target.value == 'date'){
            this.svfieldType= 'CL_Date'
        }else if(e.target.value == 'narray'){
            this.svfieldType= 'CL_NArray'    

        }else{
            this.svfieldType= 'CL_Number'
        }

        this.setState({
            svfieldType:this.svfieldType
        })
*/
    }
    componentWillReceiveProps(next){
        console.log('props changed SVString')
    }
   
    render(){
        
       
          /*svj21 start*/
          console.log('***svj21****  SVICO countryTwoTypes')
          const {countryTwoTypes} = this.props

          console.log("*******svj2****ADoc countryTwoTypes** START")
          console.log(countryTwoTypes)

          console.log("*******svj21****ADevice** END")

            /*svj21 end*/
        let me = this
       let {member,index, placeholder ='Port Z'} = this.props
       console.log("sv aug30 **** member**")
       console.log(member)
       let mm = `${member}.mcicountryOrg`
       console.log(mm) 
       console.log("sv aug30 **** member END **")
            

          return (
            
   

                <Field  
                onChange={me.svDDChange}
                style={{maxWidth:"210px"}}
                component="select" 
                id={`${member}.mcicountryOrg`}
                name={`${member}.mcicountryOrg`}
                className="form-control" >
                                                
                                                <option value="">Country</option>
                                                    {
                                        
                                                
                                        countryTwoTypes.map(  (o, idx)=>(  <option value={o.a2} key={o.name}>{o.name}</option>)
                                                    
                                                    
                                                    
                                                
                                                )}
    
                     </Field>    
                                  
          
           )
    }
}